import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 43.883 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43.883 44\" id=\"icon-user\">\r\n  <path d=\"M43.883,44H0V36.544a12.084,12.084,0,0,1,12.068-12.1H31.815a12.085,12.085,0,0,1,12.068,12.1V44ZM22.429,21.512A10.756,10.756,0,1,1,33.156,10.755,10.755,10.755,0,0,1,22.429,21.512Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol